import { render, staticRenderFns } from "./ota-list.vue?vue&type=template&id=4e156f28&scoped=true&"
import script from "./ota-list.vue?vue&type=script&lang=js&"
export * from "./ota-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e156f28",
  null
  
)

export default component.exports